import React from 'react';
import { cn } from '../../../lib/utils';

export interface TaskyInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
  variant?: 'default' | 'chat';
}

export const TaskyInput = React.forwardRef<HTMLInputElement, TaskyInputProps>(
  ({ className, hasError, variant = 'default', disabled, ...rest }, ref) => (
    <input
      ref={ref}
      {...rest}
      disabled={disabled}
      className={cn(
        'w-full h-10 px-3 text-base text-dark placeholder:text-gray-400',
        'bg-white border transition-colors',
        'focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary',
        variant === 'default' && 'border-warm-border rounded-tasky-sm',
        variant === 'chat' && 'border-warm-border rounded-full bg-gray-50 px-4',
        hasError && 'border-destructive focus:ring-destructive/30 focus:border-destructive',
        disabled && 'bg-gray-100 text-gray-500 cursor-not-allowed',
        className,
      )}
    />
  ),
);
TaskyInput.displayName = 'TaskyInput';
